import React from 'react'

import { CardImageAltInfo, CardImageBox, CardPicture } from '@components/CardsList/index.styles'

interface CardImageProps {
  imageSrc?: string
  imageAltInfo?: string
  overlapSize?: number
  itemWidth?: number
  isDisabled?: boolean
  isClickable?: boolean
}

const CardImage = (props: CardImageProps) => {
  const { imageSrc, imageAltInfo, itemWidth, overlapSize = 0, isDisabled, isClickable } = props

  if (!imageSrc && !imageAltInfo) {
    return null
  }

  return (
    <CardImageBox
      $overlapSize={overlapSize}
      $itemWidth={itemWidth}
      $isDisabled={isDisabled}
      $isClickable={isClickable}
      data-testid="card-image-box"
    >
      {imageSrc ? (
        <CardPicture $isDisabled={isDisabled} alt={imageAltInfo} src={imageSrc} />
      ) : (
        <CardImageAltInfo $isDisabled={isDisabled} $itemWidth={itemWidth}>
          {imageAltInfo}
        </CardImageAltInfo>
      )}
    </CardImageBox>
  )
}

export default CardImage
